export default __webpack_public_path__ + "static/media/02_s.4d2e8152.png";